const styles = theme => ({
  title: {
    fontFamily: 'Roboto-Bold',
    fontSize: 32,
    color: '#003366',

    [theme.breakpoints.down('sm')]: {
      fontSize: 26,
    }
  },
  subTitle: {
    fontFamily: 'Roboto-Bold',
    fontSize: 24,
    color: '#003366',

    [theme.breakpoints.down('sm')]: {
      fontSize: 18,
    }
  },
  logo: {
    height: 80,
    width: '100% !important',
  },
  contactsImage: {
    width: 272,
    marginTop: -theme.spacing(5),
    [theme.breakpoints.down('sm')]: {
      marginTop: -theme.spacing(1),
    }
  },
  blueContainer: {
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(8),
      '& .processDescription': {
        paddingRight: theme.spacing(7),
      }
    },
    padding: theme.spacing(2),
    background: '#E2E8F0',
    borderRadius: 16,
    marginBottom: theme.spacing(2),
    '& img': {
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: 282
      }
    }
  },
  flowDescription: {
    fontSize: 16
  },
  whiteContainer: {
    background: '#FFF',
    borderRadius: 16,
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(6),
      '&:first-child': {
        marginRight: theme.spacing(2),
      },

      '&:last-child': {
        marginLeft: theme.spacing(2),
      }
    },

    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(2),
      '&:first-child': {
        marginBottom: theme.spacing(2),
      }
    }
  }
});

export default styles;